import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`PWA Studio version`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Magento core version`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`14.2.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.7-p4`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`14.1.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.7-p2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`14.0.1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.7-beta3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`14.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.7-beta3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`13.3.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.7-beta2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`13.2.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.7-beta1`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`13.1.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.6`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`13.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.7.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.6.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.5.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.4`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.4.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.4`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.3.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.2.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.1.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`12.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`11.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`10.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`9.0.1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`9.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`8.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.4.0 - 2.4.1`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`7.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.5 - 2.4.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`6.0.1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.4 - 2.3.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`6.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.4 - 2.3.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`5.0.1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.3 - 2.3.4`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`5.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.3 - 2.3.4`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`4.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.2 - 2.3.3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`3.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.1 - 2.3.2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.1.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.1`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.3.0`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      